import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be959b34"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal is-active",
  ref: "paymentRequest"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "modal-card"
}
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = { class: "modal-card-title is-title-shrink" }
const _hoisted_6 = { class: "modal-card-body" }
const _hoisted_7 = { class: "body-content is-size-4" }
const _hoisted_8 = { class: "custom-card-title has-text-weight-bold" }
const _hoisted_9 = { class: "confirm-icon-container" }
const _hoisted_10 = { class: "amount has-text-weight-bold is-size-4" }
const _hoisted_11 = { class: "frame3-sub-title" }
const _hoisted_12 = { class: "frame3-sub-title has-text-weight-bold is-size-3 hide-overflow" }
const _hoisted_13 = { class: "frame3-sub-title" }
const _hoisted_14 = { class: "frame3-sub-title has-text-weight-bold is-size-3 hide-overflow" }
const _hoisted_15 = {
  key: 0,
  class: "request-message"
}
const _hoisted_16 = { class: "frame3-sub-title" }
const _hoisted_17 = { class: "message-text" }
const _hoisted_18 = { class: "frame3-sub-title mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { class: "payment-request-guidance is-size-5 mb-3" }
const _hoisted_21 = { class: "modal-card-foot custom-modal-card-foot payment-request-actions is-justify-content-flex-end" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 1,
  class: "modal-card"
}
const _hoisted_24 = { class: "modal-card-head" }
const _hoisted_25 = { class: "is-flex is-flex-shrink-0" }
const _hoisted_26 = { class: "icon has-text-white" }
const _hoisted_27 = { class: "modal-card-title is-title-shrink" }
const _hoisted_28 = { class: "modal-card-body" }
const _hoisted_29 = { class: "field" }
const _hoisted_30 = { class: "label" }
const _hoisted_31 = { class: "control" }
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_34 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_35 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.$modal.step.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$gettext("Payment request details")), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$modal.close()))
            })
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.statusTitle), 1),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_fa_icon, {
                  icon: _ctx.statusIcon,
                  class: _normalizeClass(["confirm-icon fa-thin", _ctx.paymentRequest.state])
                }, null, 8, ["icon", "class"])
              ]),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.amountSentence), 1),
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$gettext("from")), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.paymentRequest.jsonData.sender_name), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.$gettext("to")), 1),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.paymentRequest.jsonData.receiver_name), 1)
              ]),
              (_ctx.paymentRequest.message)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.$gettext("Description")), 1),
                    _createElementVNode("p", _hoisted_17, "“" + _toDisplayString(_ctx.paymentRequest.message) + "”", 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_18, [
                (_ctx.paymentRequest.creatorName)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.createdBySentence), 1),
                      _hoisted_19
                    ], 64))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.createdOnSentence), 1)
              ]),
              _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.paymentRequestGuidance), 1)
            ])
          ]),
          _createElementVNode("footer", _hoisted_21, [
            (_ctx.paymentRequest.isSender && _ctx.paymentRequest.state === 'open')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button custom-button-modal has-text-weight-medium",
                  disabled: _ctx.isPaymentInProgress,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pay()))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Pay")), 1)
                ], 8, _hoisted_22))
              : _createCommentVNode("", true),
            (_ctx.paymentRequest.isSender && _ctx.paymentRequest.state === 'open')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "button custom-button-modal has-text-weight-medium",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openAction('refuse')))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Refuse")), 1)
                ]))
              : _createCommentVNode("", true),
            (
              _ctx.paymentRequest.isCreator &&
              (_ctx.paymentRequest.state === 'open' ||
                _ctx.paymentRequest.state === 'refused')
            )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "button custom-button-modal has-text-weight-medium",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openAction('cancel')))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Cancel")), 1)
                ]))
              : _createCommentVNode("", true),
            (
              _ctx.paymentRequest.state === 'paid' ||
              _ctx.paymentRequest.state === 'cancelled'
            )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "button custom-button-modal has-text-weight-medium",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$modal.close()))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Ok")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$modal.step.value == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("header", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, [
              _createElementVNode("a", {
                class: "mr-3 is-flex",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$modal.back()))
              }, [
                _createElementVNode("span", _hoisted_26, [
                  _createVNode(_component_fa_icon, {
                    icon: "arrow-left",
                    class: "fa-lg"
                  })
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.actionType === "refuse"
                ? _ctx.$gettext("Refuse payment request")
                : _ctx.$gettext("Cancel payment request")), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$modal.close()))
            })
          ]),
          _createElementVNode("section", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.actionType === "refuse"
                  ? _ctx.$gettext("Explanation")
                  : _ctx.$gettext("Explanation (optional)")), 1),
              _createElementVNode("div", _hoisted_31, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "textarea",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.explanation) = $event)),
                  placeholder: _ctx.$gettext('Add an explanation...'),
                  rows: "3"
                }, null, 8, _hoisted_32), [
                  [_vModelText, _ctx.explanation]
                ])
              ]),
              (_ctx.explanationError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.explanationError), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("footer", _hoisted_34, [
            _createElementVNode("button", {
              class: "button custom-button-modal has-text-weight-medium",
              disabled: Boolean(_ctx.explanationError) || _ctx.isActionInProgress,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.confirmAction()))
            }, _toDisplayString(_ctx.actionType === "refuse"
                ? _ctx.$gettext("Refuse")
                : _ctx.$gettext("Cancel request")), 9, _hoisted_35)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}